import React from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';

import './_container.scss';

const Container = ({ children, containerStyle }) => {
  const containerClass = c('container', containerStyle);

  return (
    <div className={containerClass}>
      {children}
    </div>
  );
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  containerStyle: PropTypes.string
};

export default Container;
